import AdminPage from 'admin/components/AdminPage'
import { VideoTrainingSection } from 'admin/interfaces'
import { deleteSection, getVideoSections, reorderVideos, saveSection } from 'admin/services/training/net'
import ConfirmDialog from 'components/ConfirmDialog'
import useAsyncAction from 'hooks/useAsyncAction'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes, useLocation, useNavigate } from 'react-router'
import { firstValueFrom } from 'rxjs'
import { message } from 'services/snackbar'
import { StoreThunkDispatch } from 'store/state'
import { SectionDetails } from './components/SectionDetails'
import { SectionList } from './components/SectionList'

export function VideoTrainingConfig() {
  const navigate = useNavigate()
  const dispatch = useDispatch<StoreThunkDispatch>()
  const location = useLocation()
  const fetchData = () => {
    return dispatch(getVideoSections(true))
  }

  const [getSections, sections, error, loading] = useAsyncAction(fetchData)

  useEffect(() => {
    if (location.pathname === '/admin/onboarding/video-training') {
      getSections()
    }
  }, [getSections, location.pathname])

  const onEditSection = (c: VideoTrainingSection) => {
    navigate(`/admin/onboarding/video-training/section/${c.id}`)
  }

  const createNewSection = (title: string, slug: string, label: string) => {
    const data = { title, slug, label }
    firstValueFrom(dispatch(saveSection(data, undefined, sections.length.toString())))
      .then(() => {
        getSections()
        dispatch(message('Section created!'))
      })
      .catch(error => {
        console.log('[error]', error)
        dispatch(message(`Error: ${error.message}`))
      })
  }

  const onDelete = (c: VideoTrainingSection) => {
    firstValueFrom(dispatch(deleteSection(c.id)))
      .then(() => {
        getSections()
        dispatch(message('Section deleted!'))
      })
      .catch(e => {
        console.log('[error]', e)
        const msg = e.response.error?.message || e.message
        dispatch(message(`Error: ${msg}`))
      })
  }

  useEffect(() => {
    if (error) {
      const msg = (error as any).response?.error.message
      dispatch(message(`Error: ${msg}`))
    }
  }, [dispatch, error])

  const onReorder = (ids: number[]) => {
    firstValueFrom(dispatch(reorderVideos('section', ids)))
      .then(() => {
        dispatch(message('Sections reordered!'))
      })
      .catch(e => {
        console.log('[error]', e)
        dispatch(message(`Reordering error: ${e.message}`))
      })
  }

  if (!sections) {
    return null
  }

  return (
    <AdminPage title="Home page">
      {loading && <div>Loading...</div>}
      {error && <div>Error: {JSON.stringify(error)}</div>}
      {!loading && !error && (
        <ConfirmDialog message="Delete section?" variant="danger" confirmLabel="Delete">
          {(confirm) => (
            <Routes>
              <Route
                index
                element={(
                  <SectionList
                    sections={sections}
                    onCreateSection={createNewSection}
                    onDeleteSection={confirm(onDelete)}
                    onEditSection={onEditSection}
                    onReorder={onReorder}
                  />
                )}
              />
              <Route path="section/:sectionId" element={<SectionDetails sections={sections} />} />
            </Routes>
          )}
        </ConfirmDialog>
      )}
    </AdminPage>
  )
}
